











































































import Vue, { PropType } from "vue"
import PHeader from "./PHeader.vue"
import CardListItem from "~/components/guideline/cardList/CardListItem.vue"
import FavoriteIcon from "~/components/guideline/icon/FavoriteIcon.vue"

export default Vue.extend({
  components: {
    CardListItem,
    FavoriteIcon,
    PHeader,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    linkPath: {
      type: String,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    labels: {
      type: Array as PropType<String[]>,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    limitDate: {
      type: String,
      default: null,
    },
    publishedEndDate: {
      type: String,
      default: null,
    },
    corporationLogoImageUrl: {
      type: String,
      default: null,
    },
    corporationName: {
      type: String,
      default: null,
    },
    isClosedApplication: {
      type: Boolean,
      required: true,
    },
    // お気に入りアイコンを表示するかどうかを示すフラグ
    enableFavorite: {
      type: Boolean,
      default: false,
    },
    // お気に入りされているかどうかを示すフラグ
    isFavorited: {
      type: Boolean,
      default: null,
    },
    // 新着プロジェクトであるかどうかを示すフラグ
    isNew: {
      type: Boolean,
      default: false,
    },
    recruitmentLargeJobCategoryId: {
      type: Number,
      required: true,
    },
    headerImagePatternNo: {
      type: Number,
      required: true,
    },
  },
  computed: {
    shouldShowNewTag(): boolean {
      // 「募集終了」された場合、プロジェクトが新着かどうか(isNew)にかかわらず、「新着」は非表示
      return !this.isClosedApplication && this.isNew
    },
  },
  methods: {
    handleClickFavoriteIcon() {
      this.$emit("click-favorite-icon")
    },
    handleClickLink() {
      this.$gtag("event", "click_project", {
        projectId: this.projectId,
        title: this.title,
        job: this.role,
        labels: this.labels,
        corporationName: this.corporationName,
      })
    },
  },
})
